export const SENTRY_SDN_URL =
  'https://40689a38f2e947d6a7072c21724347c0@trace.bantouyan.com/16'
